<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { regionStore } from "$lib/stores/region";
  import RegionSelectorModal from "$lib/components/RegionSelector/RegionSelectorModal/RegionSelectorModal.svelte";
  import { gotoRegion } from "$lib/components/RegionSelector";

  const regionInfo = regionStore();

  export let country = $regionInfo && $regionInfo.country;
  export let language =
    $regionInfo && $regionInfo.locale && $regionInfo.locale.toUpperCase();
  export let caption = false;
  export let theme = "on-surface";

  $: if ($regionInfo && $regionInfo.country) {
    country = $regionInfo.country;
  }
  $: if ($regionInfo && $regionInfo.locale) {
    language = $regionInfo.locale.toUpperCase();
  }

  let modal;
  let openModal = false;
</script>

<style lang="scss">
  button {
    display: flex;
    background-color: transparent;
    color: $on-surface;
    align-items: center;
    border: none;
    padding: 0;
  }
</style>

<button
  type="button"
  on:click|stopPropagation={() => {
    modal.open();
    openModal = true;
  }}
>
  <Typography
    component="span"
    variant={`${caption ? "caption1" : "button1"}`}
    {theme}
  >
    {#if country}
      {country}
    {/if}
    {#if country && language}
      |
    {/if}
    {#if language}
      {language}
    {/if}
  </Typography>
</button>

<RegionSelectorModal
  isOpen={openModal}
  countryCode={country}
  bind:modal
  on:confirm={e => {
    gotoRegion(e.detail, regionInfo);
  }}
  on:continue
/>
